import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ContentfulService {
  url = 'https://cdn.contentful.com/spaces';
  space = 'ddn3e0tv8uhl';

  constructor(private http: HttpClient) {}

  get(type: string): Observable<any> {
    const params = this.params;
    params.content_type = type;

    return this.http.get(`${this.url}/${this.space}/entries`, {
      params,
    });
  }

  getByResource(l: string, type: string, resource: string): Observable<any> {
    const params = this.params;
    params.content_type = type;
    params['fields.resource'] = resource;
    params['fields.language'] = l;

    return this.http
      .get(`${this.url}/${this.space}/entries`, {
        params,
      })
      .pipe(
        map((res: any) => {
          if (!res.items[0]) {
            return null;
          }

          return res.items[0];
        }),
      );
  }

  private get params(): any {
    return {
      access_token:
        'a6931eef8ac53f8e92da8a6bb739e6373c8a9d586ac409938e2a3d129b529767',
    };
  }
}
